import React from 'react'
import type { SelectInlineInputProps, SelectOption } from '@ztechapps/webui.input'
import { Select, SelectInlineInput, buildEnumOptions } from '@ztechapps/webui.input'
import type { StatusColor } from '@ztechapps/common.contract'
import { Status, StatusEnum, StatusToneEnum } from '@ztechapps/common.contract'
import { StatusColorBadge } from '@ztechapps/webui.util'

// An unknown value paints the Draft tone.
const getStatusColor = (status: string): StatusColor => Status[status] ?? { tone: StatusToneEnum.Draft }

export const statusOptions = buildEnumOptions(StatusEnum)

export const StatusSelect = ({ ...rest }) => {
  return (
    <Select
      {...{
        ...rest,
        options: statusOptions,
      }}
    />
  )
}

export const StatusSelectInlineInput = (props: SelectInlineInputProps) => {
  return (
    <SelectInlineInput
      {...props}
      selectComponent={StatusSelect}
      selectOptions={statusOptions}
      displayContent={
        props.displayContent ??
        ((option: SelectOption) => <StatusColorBadge status={option.value} color={getStatusColor(option.value)} />)
      }
    />
  )
}
